import UntrackedInboundCallsFilters from 'components/templates/untrackedInboundCalls/filters';
import UntrackedInboundCallsHeader from 'components/templates/untrackedInboundCalls/header';
import UntrackedInboundCallsTable from 'components/templates/untrackedInboundCalls/table';

const UntrackedInboundCallsPage = () => {
  return (
    <>
      <UntrackedInboundCallsHeader />
      <UntrackedInboundCallsFilters />
      <UntrackedInboundCallsTable />
    </>
  );
};

export default UntrackedInboundCallsPage;
